<template>

    <m-edit1/>

    <m-update-site-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-update-site-message-1><m-loading-3 v-bind='{...{},...{}}' :style='""' class="" ></m-loading-3><router-view name='site' v-bind='{...{},...{}}' :style='""' class='""' /><m-chat-widget-1 v-bind='{...{"enableAnimation":false},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-chat-widget-1><m-div v-bind='{...{},...{}}' :style='"width:480px;\nbox-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;"' class="row m-0 p-0 mx-auto  fixed-bottom  rounded  bg-white  inner-container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="flex-fill pt-3 col-4 text-center" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"Home\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-icon v-bind='{...{"icon":"house-door"},...{}}' :style='""' class="h4 text-muted color-hover" ></m-icon><m-p v-bind='{...{},...{}}' :style='"font-size:13px;"' class="small text-muted " >
                <template #default>خانه   </template>
                </m-p></template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="flex-fill pt-3 col-4 text-center" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"Products\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-icon v-bind='{...{"icon":"shop-window"},...{}}' :style='""' class="h4  text-muted  color-hover" ></m-icon><m-p v-bind='{...{},...{}}' :style='"font-size:13px;"' class="text-muted " >
                <template #default>فروشگاه   </template>
                </m-p></template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="flex-fill pt-3 col-4 text-center" >
                <template #default>   <m-a v-bind='{...{"href":"{\"name\":\"profile\",\"params\":{}}","target":"_self"},...{}}' :style='""' class="" >
                <template #default>   <m-icon v-bind='{...{"icon":"person-circle"},...{}}' :style='""' class="h4  text-muted color-hover" ></m-icon><m-p v-bind='{...{},...{}}' :style='"font-size:13px;"' class="text-muted " >
                <template #default>حساب کاربری   </template>
                </m-p></template>
                </m-a></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mUpdateSiteMessage1 from '@moeinmdn/miw-alpha-components/src/package/UpdateSiteMessage/UpdateSiteMessage1'; import mLoading3 from '@moeinmdn/miw-alpha-components/src/package/Loading/Loading3'; import mChatWidget1 from '@moeinmdn/miw-alpha-components/src/package/Chat/Widget/ChatWidget1'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mIcon from '@moeinmdn/miw-alpha-components/src/package/Icons/Icon'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P';

export default {
    name: 'HomeView',
    components: {mEdit1, mUpdateSiteMessage1,mLoading3,mChatWidget1,mDiv,mA,mIcon,mP },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
